import { Card, Typography, useMobile } from '@sonnen/web-ui';
import { parseHtmlTags } from '@sonnen/web-utils';
import Tariff700 from '../../assets/images/AddTariff_mobile.webp';
import Tariff1400 from '../../assets/images/AddTariff_wide.webp';
import WinterScene from '../../assets/images/WinterScene.webp';
import WinterScene2 from '../../assets/images/WinterScene@2.webp';
import CroppedImage from '../../components/CroppedImage/CroppedImage';
import { useTranslation } from '../../i18n/i18n';

export const BatteryOptimizationCards = () => {
  const { t } = useTranslation();
  const mobile = useMobile();
  const imageHeight = mobile ? 230 : 280;
  const imageSrc = mobile ? Tariff700 : Tariff1400;

  return (
    <>
      <Card paddingSize="none">
        <CroppedImage
          height={imageHeight}
          src={imageSrc}
          srcSet={`${Tariff700} 400w, ${Tariff1400} 1400w`}
          dataTestId="battery-image"
          objectPosition="left top"
          noBottomRadius
        />
        <Card withBottomSpace={false} className="gap" paddingSize="md">
          <Typography.H2>{t(`batteryOptimization.card2title`)}</Typography.H2>
          <Typography.Body1>{t(`batteryOptimization.card2text`)}</Typography.Body1>
          <p>
            <Typography.Number4>{t(`batteryOptimization.upto`)}</Typography.Number4>{' '}
            <Typography.Number1>{t(`batteryOptimization.uptoPercent`)}</Typography.Number1>
            <br />
            <Typography.Body1 variant="secondary">
              {t(`batteryOptimization.uptoText`)}
            </Typography.Body1>
          </p>
        </Card>
      </Card>

      <Card paddingSize="none">
        <CroppedImage
          height={280}
          src={WinterScene2}
          srcSet={`${WinterScene} 1x, ${WinterScene2} 2x`}
          dataTestId="battery-image-2"
          noBottomRadius
        />

        <Card className="gap" paddingSize="md">
          <Typography.H2>{t(`batteryOptimization.card3title`)}</Typography.H2>
          <Typography.Body1>{parseHtmlTags(t(`batteryOptimization.card3text`))}</Typography.Body1>
        </Card>
      </Card>
    </>
  );
};
